// extracted by mini-css-extract-plugin
export default {"center":"Specifications_center__0FfxL","heroImage":"Specifications_heroImage__BQ-F4","buttonGrid":"Specifications_buttonGrid__zXHLm"};